import { responseHero } from "../utils/axiosInterceptor";
import { HumanPayoutsWithPortfolioData } from "../models/types/HumanPayoutsWithPortfolioData";

export const getPayoutRegisterWithPortfolioData = (): Promise<HumanPayoutsWithPortfolioData[]> => {
    return new Promise<HumanPayoutsWithPortfolioData[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/payouts`).then((response) => {
            resolve(response.data as HumanPayoutsWithPortfolioData[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};
